import AppTextarea from './components/AppTextarea.vue';
import Vue from './core/Vue';
import DiscussionEditor from './components/Discussions/DiscussionEditor.vue';
import DiscussionText from './components/Discussions/DiscussionText.vue';
import DiscussionTarget from './components/Discussions/DiscussionTarget.vue';
import DiscussionHistory from './components/Discussions/DiscussionHistory.vue';
Vue.component('AppTextarea', AppTextarea);
Vue.component('DiscussionEditor', DiscussionEditor);
Vue.component('DiscussionText', DiscussionText);
Vue.component('DiscussionTarget', DiscussionTarget);
Vue.component('DiscussionHistory', DiscussionHistory);
import { abilitiesPlugin } from "@casl/vue";
import abilities from './utils/Abilities/abilities';
Vue.use(abilitiesPlugin, abilities(store.getters.currentUser));
import router from './router'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import App from './App.vue';
import store from './store/store';
import vSelect from 'vue-select';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './styles/sticky-table.css'
import './styles/request-card-colors.css'
import './static/css/dashboard.css'
import './static/css/index.styl'
import './styles/soft-glass.css'
import './styles/user-quote.css'
import './views/Requests/requestsGlass.css'
import './static/fontawesome-free-5.12.1-web/css/all.css'
import 'vue-select/dist/vue-select.css';
import underscore from 'vue-underscore';
import disableNumberInputWheel from './utils/disableNumberInputWheel';
import fileViewer from './components/AppFileViewer';
import {registerNotificationServiceWorker} from './utils/notificationPermission';
import {formatPhone, phoneHref, telegramPhoneHref} from './utils/phone';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component(`vSelect`, vSelect);
Vue.use(underscore);
Vue.use(fileViewer);
disableNumberInputWheel();
registerNotificationServiceWorker();
Vue.filter('phone', formatPhone);
Vue.prototype.$formatPhone = formatPhone;
Vue.prototype.$phoneHref = phoneHref;
Vue.prototype.$telegramPhoneHref = telegramPhoneHref;

const moment = require('moment')
require('moment/locale/ru');
Vue.use(require('vue-moment'), {
    moment
})
// Vue.prototype.$moment = moment;
Vue.use(require(`chartjs-adapter-moment`));
new Vue({
    router,
    render: h => h(App),
    store,
}).$mount('#app');
